import { createStore } from "@stencil/store";
import { UserData } from '@helpers/user-data';

export const { state, set, onChange } = createStore({
  userName: null,
  userSurname: null,
  userWallet: null,
    userId: null,
    setUserApiKey: null
});

onChange('userWallet', value => {
    state.userWallet = value;
    // lancia un evento che mi mandi il valore aggiornato di userWallet e poi questo evento lo ascolto in page-profile

    document.dispatchEvent(new CustomEvent('userWalletUpdated', {
        detail: {
            userWallet: value
        }
    }));
});

export const setUserId = async (id) => {
    await UserData.setUserId(id);
    state.userId = id;
};



export const setUserSurname = async (surname) => {
    await UserData.setUserSurname(surname);
    state.userSurname = surname;
};

export const setUserApiKey = async (key) => {
    await UserData.setUserApiKey(key);
    state.setUserApiKey = key;
};

export const setUserWallet = async (wallet) => {
    await UserData.setUserWalletAddress(wallet);
    state.userWallet = wallet;
};

export const clearUserWallet = async () => {
    await UserData.clearUserWalletAddress();
    state.userWallet = undefined;
};

export const setUserName = async (name) => {
    await UserData.setUserName(name);
    state.userName = name;
};

export const getUserName = async () => {
    if(state.userName === null){
        await UserData.getUserName().then((res) => {
            state.userName = res;
        });
        return state.userName;
    } 
    return state.userName;
};



export const getUserSurname = async () => {
    if(state.userSurname === null){
        await UserData.getUserSurname().then((res) => {
            state.userSurname = res;
        });
        return state.userSurname;
    } 
    return state.userSurname;
};

export const getUserWallet = async () => {
    if(state.userWallet === null){
        await UserData.getUserWalletAddress().then((res) => {
            state.userWallet = res;
        });
        return state.userWallet;
    } 
    return state.userWallet;
};